const MenuItemCard = ({
  item,
  orderedItems,
  handleSelectedItem,
  loadingItemId,
  disabled = false,
}) => {
  const isLoading = loadingItemId === item.id; // Show spinner only for the current loading item

  const getItemQuantity = () => {
    const orderedItem = orderedItems?.find((ordered) => ordered.id === item.id);
    if (!orderedItem) return 0;

    // If item has variants, sum up quantities of all variant items
    if (orderedItem?.has_variants) {
      return orderedItem.items?.reduce((total, variantItem) => total + variantItem.quantity, 0);
    }
    
    // For non-variant items, return the quantity directly
    return orderedItem.quantity || 0;
  };

  return (
    <div 
      className={`flex gap-4 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`} 
      onClick={() => !isLoading && !disabled && handleSelectedItem(item, "add")}
    >
      {/* Spinner Overlay */}
      {isLoading && (
        <div className="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center z-[60]">
          <div className="spinner-border animate-spin border-t-4 border-b-4 border-gray-600 w-8 h-8 rounded-full"></div>
        </div>
      )}
      <div className="w-[100px] h-[100px] bg-gray-100 border border-[#DFE4EA] rounded-md z-50 overflow-hidden">
        <img
          src={item.thumb_image}
          alt="Thumbnail"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1">
        <h3 className="text-xs font-bold text-gray-500">
          {item.category_name_en}
        </h3>
        <h2 className="text-xs font-semibold">{item.name_en}</h2>
        <p className="text-[8px] text-gray-600 mt-1 line-clamp-2 overflow-hidden">
          {item.description_en || "No description available."}
        </p>
        <h2 className="text-xs font-semibold mt-1">{item.price}</h2>
        <div className="flex items-center absolute bottom-2 right-2" onClick={e => e.stopPropagation()}>
          <button
            onClick={() => !disabled && handleSelectedItem(item, "remove")}
            className="w-6 h-6 border border-gray-300 rounded-full flex items-center justify-center text-base leading-none"
            disabled={isLoading || disabled}
          >
            <span className="inline-block" style={{ marginBottom: '2px' }}>-</span>
          </button>
          <span className="mx-2 text-xs">
            {getItemQuantity()}
          </span>
          <button
            onClick={() => !disabled && handleSelectedItem(item, "add")}
            className="w-6 h-6 border border-gray-300 rounded-full flex items-center justify-center text-base leading-none"
            disabled={isLoading || disabled}
          >
            <span className="inline-block" style={{ marginLeft: '0.5px', marginBottom: '1px' }}>+</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuItemCard;
